<script>
	export let active;
	export let selected;
	const baseURL =
		"https://native-count.netlify.app/.netlify/functions/fetch/?articleID=tg4-";
	$: interactionURL = `${baseURL}section-${selected}`;

	const local = document.location.href.includes("localhost");

	$: if (local && active !== null) {
		console.log(interactionURL);
	}
</script>

{#if !local && active !== null}
	<img src={interactionURL} role="presentation" alt="" />
{/if}

<style>
	img {
		opacity: 0;
	}
</style>
